import React from 'react';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { SidebarProvider } from './contexts/SidebarContext';
import AppRouter from './router';

function App() {
  return (
    <AuthProvider>
      <SidebarProvider>
        <Toaster />
        <AppRouter />
      </SidebarProvider>
    </AuthProvider>
  );
}

export default App;
